import { Helmet } from 'react-helmet-async';

/**
 * Per-page SEO/Helmet helper.
 * - Sets <title>, meta description, canonical, OG and Twitter tags.
 * - Pass `noindex` to mark dynamic / private routes (dashboard, payment success).
 *
 * Defaults fall back to the homepage values that already live in index.html,
 * so social scrapers still get a valid card even if a page forgets to override.
 */
const SITE_URL = 'https://herita.me';
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.jpg?v=2`;

const SEO = ({
  title,
  description,
  path = '/',
  ogTitle,
  ogDescription,
  ogImage = DEFAULT_OG_IMAGE,
  noindex = false,
}) => {
  const canonical = `${SITE_URL}${path}`;
  const _ogTitle = ogTitle || title;
  const _ogDescription = ogDescription || description;
  return (
    <Helmet prioritizeSeoTags>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={canonical} />
      <meta
        name="robots"
        content={
          noindex
            ? 'noindex, nofollow'
            : 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1'
        }
      />

      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content="Hérita" />
      <meta property="og:locale" content="fr_FR" />
      {_ogTitle && <meta property="og:title" content={_ogTitle} />}
      {_ogDescription && <meta property="og:description" content={_ogDescription} />}
      <meta property="og:image" content={ogImage} />

      <meta name="twitter:card" content="summary_large_image" />
      {_ogTitle && <meta name="twitter:title" content={_ogTitle} />}
      {_ogDescription && <meta name="twitter:description" content={_ogDescription} />}
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default SEO;
